import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";
export default class BroadcastAnalyticsService extends AxiosBase {
  getAllBroadcasts = async ({ page, limit }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BROADCAST.GET_BROADCAST}?page=${page}&limit=${limit}`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  getBroadcastsByOrgId = async ({ page, limit, id }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BROADCAST.GET_BROADCAST}?organisationId=${id}&page=${page}&limit=${limit}`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  getBroadcastInfo = async (id) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BROADCAST.GET_BROADCAST}/${id}`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  exportSentUsers = async (payload) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BROADCAST.EXPORT_SENT_USERS}`,
        payload
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) throw err;
    }
  };
  exportFailedUsers = async (payload) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BROADCAST.EXPORT_FAILED_USERS}`,
        payload
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) throw err;
    }
  };
}
